import {z} from 'zod';

/**
 * Makes zod word its problems in English everywhere in the app. zod installs
 * its English messages as a module side effect, and declares no side effects,
 * so a production bundle drops them and every message a user sees reads
 * "Invalid input". An explicit call keeps the messages in the bundle.
 * {@link bootstrapCipApp} calls it before the app renders.
 *
 * @return Nothing.
 * @throws Never.
 */
export function installZodEnglishMessages(): void {
  z.config(z.locales.en());
}
